<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="85px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户编号" prop="customerNum">
            <el-input v-model="queryParams.customerNum" placeholder="请输入客户编号" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户级别" prop="customerLevelList">
            <el-select v-model="queryParams.customerLevelList" placeholder="请选择客户级别" allow-create filterable clearable multiple
                       style="width:100%">
              <el-option v-for="dict in customerLevelOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户来源" prop="sourceList">
            <el-select v-model="queryParams.sourceList" placeholder="请选择客户来源" allow-create filterable clearable multiple style="width:100%">
              <el-option v-for="dict in sourceOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户状态" prop="status">
            <el-select v-model="queryParams.status" placeholder="请选择客户状态" clearable style="width:100%">
              <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户性质" prop="customerNatureList">
            <el-select v-model="queryParams.customerNatureList" placeholder="请选择客户性质" allow-create filterable clearable multiple
                       style="width:100%">
              <el-option v-for="dict in natureOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户类型" prop="customerTypeList">
            <el-select v-model="queryParams.customerTypeList" placeholder="请选择客户类型" allow-create filterable clearable multiple
                       style="width:100%">
              <el-option v-for="dict in typeOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="是否有商机" prop="hasBusiness">
            <el-select v-model="queryParams.hasBusiness" placeholder="请选择是否有商机" clearable style="width:100%">
              <el-option v-for="dict in hasBusinessOptions" :key="dict.dictValue" :label="dict.dictLabel"
                         :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进情况" prop="followInfo">
            <el-select v-model="queryParams.followInfo" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="dict in followInfoList" :key="dict.value" :label="dict.label" :value="dict.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="区域" prop="area">
            <el-cascader v-model="queryParams.area" :options="areaOptions" :props="{ checkStrictly: true }"
                         style="width:100%" filterable clearable></el-cascader>
          </el-form-item>
        </el-col>
        <dept-user-select ref="managerDeptUserSelectRef" :deptLabel="'负责人部门'" :userLabel="'负责人'"
                          :deptIdField="'managerDeptIdList'"
                          :userIdField="'managerIdList'" :authCheck="false"
                          :formParam="queryParams" :autoSelectUser="autoSelectUser"></dept-user-select>
        <dept-user-select ref="deptUserSelectRef" :deptLabel="'创建人部门'" :userLabel="'创建人'" :userIdField="'createByList'"
                          :authCheck="false"
                          :formParam="queryParams" :autoSelectUser="false"></dept-user-select>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" v-if="customerAssignAuth" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部客户" name="all"></el-tab-pane>
      <el-tab-pane label="公海客户" name="publicPool"></el-tab-pane>
      <el-tab-pane label="我的关注" name="myFocus"></el-tab-pane>
    </el-tabs>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :selectable="selected" width="55" fixed="left" align="center"/>
      <el-table-column label="客户名称" min-width="160" align="left" prop="customerName" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户性质" min-width="80" align="center" prop="customerNatureDesc" fixed="left"/>
      <el-table-column label="客户类型" min-width="110" align="center" prop="customerTypeDesc" fixed="left"/>
      <el-table-column label="客户编号" width="140" align="center" prop="customerNum"/>
      <el-table-column label="客户来源" width="100" align="center" prop="customerSourceDesc"/>
      <el-table-column label="客户级别" min-width="120" align="center" prop="customerLevelDesc" />
      <el-table-column label="商机数" width="80" align="center">
        <template slot-scope="scope">
          <el-link v-if="scope.row.businessCount > 0" type="primary" class="crm-link-wrap" :underline="false" @click="openBusiness(scope.row)">{{scope.row.businessCount}}</el-link>
          <span v-else>{{scope.row.businessCount}}</span>
        </template>
      </el-table-column>
      <el-table-column label="区域" width="150" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.regionName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" width="80" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.manager.managerName}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="最新跟进记录" min-width="150" align="left" show-overflow-tooltip>-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="Boolean(scope.row.lastFollowInfo)" style="text-align: left;">-->
<!--            <span>{{scope.row.lastFollowInfo.followTypeDesc}}</span>-->
<!--            <span v-if="(scope.row.lastFollowInfo.followSubTypeDesc)">-{{scope.row.lastFollowInfo.followSubTypeDesc}}</span>-->
<!--            <span>：</span>-->
<!--            <br>-->
<!--            <span>{{scope.row.lastFollowInfo.content}}</span>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="最新跟进人" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.followerName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进时间" width="170" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.createTime : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="未跟进天数" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowIntervalDay || scope.row.lastFollowIntervalDay===0 ? scope.row.lastFollowIntervalDay + "天" : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="80" align="center" prop="createUserName"/>
      <el-table-column label="客户状态" width="80" align="center" prop="statusDesc"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime" />
      <el-table-column label="关注" min-width="90" align="center" prop="focusFlag" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.focusFlag" @change="focusChange($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
          <el-button type="text"  @click="handlePlan(scope.row)">计划</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <PlanAddDialog ref="planAddDialogRef" @success="getList"></PlanAddDialog>
    <AddCustomerDialog ref="addCustomerDialogRef" @success="getList"></AddCustomerDialog>
    <BusinessListDialog ref="businessListDialogRef"></BusinessListDialog>
  </div>
</template>

<script>
import { listAllLevelArea } from "@/api/crm/area";
import { transferCascaderOptionsForProvince } from '@/utils/index'
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import PlanAddDialog from "@/views/crm/plan/planAddDialog";
import BusinessListDialog from "@/views/crm/business/businessListDialog";
import AddCustomerDialog from "@/views/crm/customer/addCustomerDialog";
import { mapState } from 'vuex'
import {listCustomer} from "@/api/crm/customer";
import {changeStatus} from "@/api/crm/focus";
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import {checkPermi} from "@/utils/permission";
import { getInfo } from '@/api/login';
export default {
  name: "CustomerManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      isAdmin:false,
      autoSelectUser: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      natureOptions: [],
      typeOptions: [],
      activeName: 'all',
      customerLevelOptions: [],
      sourceOptions: [],
      hasBusinessOptions: [
        {
          dictValue: "1",
          dictLabel: "是"
        }, {
          dictValue: "0",
          dictLabel: "否"
        }
      ],
      followInfoList: [
        { value: 1, label: "一周内有跟进"},
        { value: 2, label: "一个月内有跟进"},
        { value: 3, label: "3个月内有跟进"},
        { value: 4, label: "3个月内无跟进"},
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        customerNum: null,
        customerName: null,
        customerLevelList: [],
        sourceList: [],
        area: [],
        hasBusiness: null,
        followInfo: null,
        createTime: [],
        deptIdList: [],
        createByList: [],
        managerDeptIdList: [],
        managerIdList: [],
        customerNatureList: [],
        customerTypeList: [],
        myFocusFlag: null,
        status: null
      },
      areaOptions: [],
      statusOptions: [
        { dictValue: 0, dictLabel: "有效"},
        { dictValue: 1, dictLabel: "失效"}
      ]
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    }),
    customerAssignAuth() {
      // 分配的权限控制，非公海客户，能看到的人都能分配，公海客户指定角色才可以分配
      return this.activeName !== 'publicPool' || checkPermi(['crm:publicCustomer:assign'])
    }
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog,
    PlanAddDialog,
    BusinessListDialog,
    AddCustomerDialog,
    deptUserSelect
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    let workParams = this.$route.params // 工作台跳转进来
    if(Object.keys(workParams).length){
      this.autoSelectUser = false
      this.queryParams.createTime = workParams.createTime
      this.queryParams.managerDeptIdList = workParams.deptIdList
      this.queryParams.managerIdList = workParams.managerIdList
    }else {
      this.autoSelectUser = true
    }
    this.getList();
    this.getDicts("sys_customer_level").then(response => {
      this.customerLevelOptions = response.data;
    });
    this.getDicts("common_source").then(response => {
      this.sourceOptions = response.data;
    });
    this.getDicts("sys_customer_type").then(response => {
      this.typeOptions = response.data;
    });
    this.getDicts("customer_nature").then(response => {
      this.natureOptions = response.data;
    });
    listAllLevelArea({ level: 2 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
    console.log("获取人员信息");
    this.getCurrentUserInfo();
  },
  methods: {
    getCurrentUserInfo(){
      console.log("获取人员信息");
      getInfo().then(response => {
        this.isAdmin=response.roles.includes('gly');
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'myFocus') {
        this.queryParams.myFocusFlag = 1
        this.queryParams.publicPoolFlag = null
      } else if (tab.name === 'publicPool') {
        this.queryParams.myFocusFlag = null
        this.queryParams.publicPoolFlag = 1
        this.queryParams.managerDeptIdList = []
        this.queryParams.managerIdList = []
      } else {
        this.queryParams.myFocusFlag = null
        this.queryParams.publicPoolFlag = null
      }
      this.handleQuery()
    },
    getList() {
      this.loading = true;

      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      params.createTime = undefined;
      params.provinceCode = params.area && params.area.length > 0 ? params.area[0] : null;
      params.cityCode = params.area && params.area.length > 1 ? params.area[1] : null;
      params.area = undefined;
      params.customerNature = params.customerNature || null
      params.customerType = params.customerType || null
      listCustomer(params).then(response => {
          this.dataList = response.rows || [];
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    selected(row, index) {
      return row.canAssignFlag
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.createTime = []
      this.queryParams.deptIdList = []
      this.queryParams.managerDeptIdList = []
      this.$refs.deptUserSelectRef.deptSelect()
      this.$refs.managerDeptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !(selection.length&&this.isAdmin);
    },
    /** 商机数按钮操作 */
    openBusiness(row) {
      this.$refs.businessListDialogRef.open(row.id, row.customerName)
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/customer/detail/" + row.id, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("customer", row.id);
    },
    /** 计划按钮操作 */
    handlePlan(row) {
      this.$refs.planAddDialogRef.open("customer", row.id, !row.manager ? null : row.manager.managerId);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addCustomerDialogRef.open();
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("customer", this.ids)
    },
    focusChange (e, row) {
      let param = {
        targetId: row.id,
        targetType: 'customer',
        operateType: e ? 1 : 2 // 操作类型 1-关注 2-取消关注
      }
      changeStatus(param).then(response => {
          this.msgSuccess(e ? '关注成功' : '取消关注成功')
        }
      ).finally(() => {
        this.handleQuery()
      });
    }
  }
};
</script>
